import { onBeforeMount, onBeforeUnmount, onMounted, ref, watch, type Ref } from 'vue'
import { useTouchCount } from './use-touch-count'

export function useClickOutside(targetEls: Ref<(HTMLElement | null | undefined)[]>, effect: () => void) {
  const abortController = new AbortController()

  const touchCount = useTouchCount()
  const isMounted = ref(false)
  const isEnabled = ref(false)

  // Preventing immediate click outside on newly rendered component
  watch(
    [touchCount, isMounted],
    ([touchCount, isMounted]) => {
      if (!isMounted) return

      if (touchCount === 0 && !isEnabled.value) {
        setTimeout(() => {
          isEnabled.value = true
        }, 500)
      }
    },
    { immediate: true }
  )

  const onClick = (event: MouseEvent) => {
    if (!isEnabled.value) return

    for (const targetEl of targetEls.value) {
      if (!targetEl) continue
      if (!targetEl.contains) continue

      if (targetEl.contains(event.target as Node)) return
    }

    effect()
  }

  onBeforeMount(() => {
    isEnabled.value = false
  })

  onMounted(() => {
    document.addEventListener('click', onClick, { signal: abortController.signal })
    isMounted.value = true
  })

  onBeforeUnmount(() => {
    isMounted.value = false
    abortController.abort()
  })
}
